export default __webpack_public_path__ + "images/82ea4b9462d83a3dc7b4e3bb3ca9a133-andyIcon.svg";